import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoInputSpace]'
})
export class NoInputSpaceDirective {

  constructor() { }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    const newValue = inputValue.replace(/\s/g, ''); // Remove spaces
    inputElement.value = newValue;
  }

}
